import { Component } from "@angular/core";

@Component({
    selector: "app-admin-layout",
    standalone: false,
    templateUrl: "./admin-layout.component.html",
    styleUrl: "./admin-layout.component.scss",
})
export class AdminLayoutComponent {}
